import * as React from 'react';
import { Winder, reportRequest, ReportHistory, customerInfo, DropdownList } from '../api/dataTypes';
import moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { DropdownSelect } from '../components/dropdownSelect';
import { getCustomersListApi } from '../api/api-organizations';
import { PromiseHelper } from '../classes/promiseHelper';
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';
import { getAllWindersApi } from '../api/api-winder';
import { STORAGE } from '../api/api-account';

const timeFormat = 'h:mm a';
const minuteStep = 5;

interface State {
    systemOptions: DropdownList[];
    customerOptions: DropdownList[];
    reportRequest: reportRequest;
}

export interface Props {
    showShifts?: boolean;
    enableOwnerSelection?: boolean;
    getRecords: (reportRequest: reportRequest) => void;
}

export class DataSelectionHeader extends React.Component<Props, State> {
    recordsPromise: PromiseHelper<ReportHistory[]> = new PromiseHelper();
    winderPromiseH: PromiseHelper<Winder[]> = new PromiseHelper();
    custPromiseH: PromiseHelper<customerInfo[]> = new PromiseHelper();

    constructor(props: Props) {
        super(props);

        this.state = {
            systemOptions: [{ name: "All", value: 0 }],
            customerOptions: [{ name: "All", value: 0 }],
            reportRequest: {
                startDate: moment(new Date(Date.now()))
                    .subtract(7, "days")
                    .toDate(),
                endDate: new Date(Date.now()),
                systemId: 0,
                org: 0,
                shiftStartTime: this.props.showShifts ? 
                    moment(localStorage.getItem(STORAGE.SHIFT_START)!
                    || moment().hour(0).minute(0)).toDate() 
                    : null,
                shiftEndTime: this.props.showShifts ? 
                    moment(localStorage.getItem(STORAGE.SHIFT_END)!
                    || moment().hour(0).minute(0)).toDate() 
                    : null
    
            },
        }
    }

    componentWillUnmount() {
        this.recordsPromise.clearPromise();
        this.winderPromiseH.clearPromise();
        this.custPromiseH.clearPromise();
    }

    componentDidMount = () => {
        this.props.getRecords(this.state.reportRequest);
        this.getDropDownOptions();
    };

    getDropDownOptions = () => {

        this.winderPromiseH.newPromise(getAllWindersApi(), 
            winders => {
                let sOptions: DropdownList[] = winders.map((v: Winder)=> {
                    return { name: v.name, value: v.id };
                });
                sOptions.unshift({ name: "All", value: 0 });
                this.setState({
                    systemOptions: sOptions
                });
            }, e => {
                console.log(`Error caught in page-cutRecords.getDropDownOptions().Systems ${e}`);
                alert('Error retrieving systems');
            });

        
        this.custPromiseH.newPromise(getCustomersListApi(), 
            customers => {
                let cOptions = customers.map((c: customerInfo) => {
                    return { name: c.name, value: c.id }; 
                });

                // Add an 'ALL' selection to the beginning of the options
                cOptions.unshift({ name: "All", value: 0 });

                this.setState({
                    customerOptions: cOptions,
                });
            },e => {
                console.log(`Error caught in page-cutRecords.getDropDownOptions().Systems ${e}`);
                alert('Error getting customers');
            }
        );

        if (this.props.showShifts === true) {
            let req = this.state.reportRequest;
            let start = localStorage.getItem(STORAGE.SHIFT_START);
            req.shiftStartTime = start !== null ? new Date(start) : req.shiftStartTime;
            let end = localStorage.getItem(STORAGE.SHIFT_END);
            req.shiftEndTime = end !== null ? new Date(end) : req.shiftEndTime;
            this.setState({
              reportRequest: req  
            })
        }

    };

    render() {
        return (
            <div className="row dropdown-header-style">
                {this.props.enableOwnerSelection === true && 
                <div className="align-self-center">
                    <DropdownSelect
                        name=" Owner "
                        value={this.state.reportRequest.org}
                        options={this.state.customerOptions}
                        editValue={this.editOrg}
                    />
                </div>}
                <div className="align-self-center">
                    <DropdownSelect
                        name=" Winder "
                        value={this.state.reportRequest.systemId}
                        options={this.state.systemOptions}
                        editValue={this.editSystem}
                    />
                </div>
                <div className="d-flex ml-4">
                    <div className="m-2 dropdown-text-style">Start Date</div>
                    <DatePicker
                        className="date-entry-style"
                        required={true}
                        selected={this.state.reportRequest.startDate}
                        onChange={this.updateStartDate}

                    />
                {/* </div> */}
                {/* <div className="d-flex ml-4"> */}
                    <div className="m-2 ml-4 dropdown-text-style">End Date</div>
                    <DatePicker
                        className="date-entry-style"
                        selected={this.state.reportRequest.endDate}
                        onChange={this.updateEndDate}
                    />
                </div>
                {this.props.showShifts === true &&
                    <div className="d-flex ml-4">
                        <div className="m-2 ml-4 dropdown-text-style">Shift Start Time</div>
                        <TimePicker
                            className="date-entry-style"
                            value={this.state.reportRequest.shiftStartTime ? moment(this.state.reportRequest.shiftStartTime) : moment()}
                            onChange={this.updateShiftStart}
                            onClose={this.sendRequest}
                            format={timeFormat}
                            use12Hours
                            showSecond={false}
                            minuteStep={minuteStep}
                        />
                    {/* </div> */}
                {/* } */}
                {/* {this.props.showShifts === true && */}
                    {/* <div className="d-flex ml-4"> */}
                        <div className="m-2 ml-4 dropdown-text-style">Shift End Time</div>
                        <TimePicker
                            className="date-entry-style"
                            value={this.state.reportRequest.shiftEndTime ? moment(this.state.reportRequest.shiftEndTime) : moment()}
                            onChange={this.updateShiftEnd}
                            onClose={this.sendRequest}
                            format={timeFormat}
                            use12Hours
                            showSecond={false}
                            minuteStep={minuteStep}
                        />
                    </div>
                }
            </div>
        );
    }

    private sendRequest = () => {this.props.getRecords(this.state.reportRequest)}

    private editOrg = (name: string, value: number) => {
        let nextRequest = this.state.reportRequest;
        nextRequest.org = value;
        this.setState({ reportRequest: nextRequest });
        this.props.getRecords(nextRequest);
    };

    private editSystem = (name: string, value: number) => {
        let nextRequest = this.state.reportRequest;
        nextRequest.systemId = value;
        this.setState({ reportRequest: nextRequest });
        this.props.getRecords(nextRequest);
    };

    private updateStartDate = (e: Date) => {
        let nextRequest = this.state.reportRequest;
        nextRequest.startDate = moment(e).toDate();
        this.setState({ reportRequest: nextRequest });
        this.props.getRecords(nextRequest);
    };

    private updateEndDate = (e: Date) => {
        let nextRequest = this.state.reportRequest;
        nextRequest.endDate = moment(e).toDate();
        this.setState({ reportRequest: nextRequest });
        this.props.getRecords(nextRequest);
    };
    
    private updateShiftStart = (e: moment.Moment) => {
        let date = moment().hour(0).minute(0);
        if (e !== null) {
            date = e;
        }
        let nextRequest = this.state.reportRequest;
        nextRequest.shiftStartTime = moment(date).toDate();
        this.setState({ reportRequest: nextRequest });
        localStorage.setItem(STORAGE.SHIFT_START, moment(date).toString());
        // this.props.getRecords(nextRequest);
    };

    private updateShiftEnd = (e: moment.Moment) => {
        let date = moment().hour(0).minute(0);
        if (e !== null) {
            date = e;
        }
        let nextRequest = this.state.reportRequest;
        nextRequest.shiftEndTime = moment(date).toDate();
        this.setState({ reportRequest: nextRequest });
        localStorage.setItem(STORAGE.SHIFT_END, moment(date).toString());
        // this.props.getRecords(nextRequest);
    };
}
